import { render, staticRenderFns } from "./CancelAccountRecord.vue?vue&type=template&id=0f1c772d&scoped=true"
import script from "./CancelAccountRecord.vue?vue&type=script&lang=js"
export * from "./CancelAccountRecord.vue?vue&type=script&lang=js"
import style0 from "./CancelAccountRecord.vue?vue&type=style&index=0&id=0f1c772d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c772d",
  null
  
)

export default component.exports